import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (type, meta = "") => {
  try {
    axios.post(`${API}/analytics/event`, { type, meta });
  } catch (e) {
    /* silent */
  }
};

export const CATEGORY_META = {
  hogar: { emoji: "🧹" },
  mascotas: { emoji: "🐕" },
  acompanamiento: { emoji: "🤝" },
  recados: { emoji: "🛒" },
};
